export { EventEmitter as RuntimeEventEmitter } from 'node:events';
